import {startOfMinute} from 'date-fns';
import {useCallback, useRef, useState} from 'react';

export const useCurrentTime = (updateIntervalMilliseconds = 3000) => {
  const [now, setNow] = useState(startOfMinute(new Date()).toISOString());
  const timeoutRef = useRef<NodeJS.Timeout>();

  const updateNow = useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      setNow(startOfMinute(new Date()).toISOString());
      updateNow();
    }, updateIntervalMilliseconds);
  }, [updateIntervalMilliseconds]);

  const cancelUpdateNow = useCallback(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
  }, []);

  return {
    now,
    updateNow,
    cancelUpdateNow,
  };
};
